// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"050f3ec4","598":"efed35f9","703":"1129b64b","787":"67c7a908"}[chunkId] + ".chunk.js";
};